import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import './App.css';

import React, { useMemo } from 'react';
import { CookiesProvider } from 'react-cookie';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';

import AppSyncClient from './api/AppSyncClient';
import { StateProvider } from './GlobalStateStore';
import { chooseLocale } from './translations';
import CSATag from './Util/Csa';
import { getLocale } from './config/Config';
import PerformancePortalContainer from './PerformancePortal/PerformancePortalContainer';
import { AppToaster, ToastContextProvider } from './Util/AppToaster';
import { ApolloProvider } from '@apollo/client';

const App: React.FC = (): React.ReactElement => {
  const client = useMemo(() => AppSyncClient.getClient(), []);

  return (
    <IntlProvider
      locale={getLocale() ?? navigator.language}
      messages={chooseLocale()}
      onError={err => {
        if (err.code === 'MISSING_TRANSLATION') {
          return;
        }
        console.error(err);
      }}
    >
      <CookiesProvider>
        <StateProvider>
          <BrowserRouter>
            <ApolloProvider client={client}>
              <ToastContextProvider>
                <CSATag applicationName='AETExtendWebsite' />
                <AppToaster />
                <PerformancePortalContainer />
              </ToastContextProvider>
            </ApolloProvider>
          </BrowserRouter>
        </StateProvider>
      </CookiesProvider>
    </IntlProvider>
  );
};

export default App;
